import { z } from "zod";

export const schema = z.object({
	id_conta: z.number().int("Verifique o id_produto antes de continuar"),
	banco: z.string().max(100).min(1, "Preencha o nome do banco"), // BANCO: texto com no máximo 100 caracteres
	ag: z.string().max(10), // AG: texto com no máximo 10 caracteres
	cc: z.string().max(10), // CC: texto com no máximo 10 caracteres
	ativo: z.boolean(), // ATIVO: booleano

	saldo: z.union([z.string(), z.number()]).transform((value) => {
		// Se for string, converte para número
		if (typeof value === "string") {
			const parsedValue = parseFloat(value.replace(",", "."));
			return isNaN(parsedValue) ? 0 : parsedValue;
		}
		return value; // Já é número, mantém como está
	}),
	// data_cadastro: z.string().datetime({ offset: true }).optional(), // DATA_CADASTRO: string de timestamp opcional
	// data_movimentacao: z.string().datetime({ offset: true }).optional(), // DATA_MOVIMENTACAO: string de timestamp opcional
	// obs: z.string().max(100).optional(), // OBS: texto com no máximo 100 caracteres opcional
	// padrao: z.boolean().optional(), // PADRAO: booleano opcional
});

// Função para converter vírgula para ponto

// valor: z
// 	.number({
// 		errorMap: () => {
// 			return { message: "Informe um número válido" };
// 		},
// 	})
// 	.positive("Por favor, informe um número maior que 0"),
// rendimento: z.number().min(1, "Campo Rendimento é obrigatório"),
